import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";

import {AccountPage} from "./pages/AccountPage";
import {DashboardPage} from "./pages/DashboardPage";
import {ServicesPage} from "./pages/ServicesPage";
import {OrdersManagementPage} from "./pages/OrdersPage";
import {CSPage} from "./pages/CSPage";
import {BalancePage} from "./pages/BalancePage";
import {StatisticsPage} from "./pages/StatisticsPage";

import {URLs} from "../utils/routes";

// Default Routes
import {BuilderPage} from "./pages/BuilderPage";
import {MyPage} from "./pages/MyPage";

// Theme Routes
const GoogleMaterialPage = lazy(() => import("./modules/GoogleMaterialExamples/GoogleMaterialPage"));
const ReactBootstrapPage = lazy(() => import("./modules/ReactBootstrapExamples/ReactBootstrapPage"));
const ECommercePage = lazy(() => import("./modules/ECommerce/pages/eCommercePage"));

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <Redirect exact from="/" to={URLs.DASHBOARD}/>
        <ContentRoute path={URLs.ACCOUNT} component={AccountPage}/>
        <ContentRoute path={URLs.DASHBOARD} component={DashboardPage}/>
        <Route path={URLs.SERVICES} component={ServicesPage}/>
        <Route path={URLs.SALES} component={OrdersManagementPage}/>
        <ContentRoute path={URLs.BALANCE} component={BalancePage}/>
        <Route path={URLs.CS} component={CSPage}/>
        <Route path={URLs.STATISTICS} component={StatisticsPage}/>

        {/* Theme Default Routes*/}
        <ContentRoute path="/builder" component={BuilderPage}/>
        <ContentRoute path="/my-page" component={MyPage}/>
        <Route path="/google-material" component={GoogleMaterialPage}/>
        <Route path="/react-bootstrap" component={ReactBootstrapPage}/>
        <Route path="/e-commerce" component={ECommercePage}/>

        <Redirect to="error/error-v1"/>
      </Switch>
    </Suspense>
  );
}
